declare namespace $ {

	type $shm_hitalama_map_widget_float__widget_shm_hitalama_map_widget_any_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_any['widget'] >
		,
		ReturnType< $shm_hitalama_map_widget_float['widget'] >
	>
	type $shm_hitalama_map_widget_float__Map_page_shm_hitalama_map_widget_any_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_any['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_widget_float['Map_page'] >
	>
	export class $shm_hitalama_map_widget_any extends $mol_ghost {
		widget( ): $shm_hitalama_map_widget
		Map_page( ): $shm_hitalama_map_page
		Application( ): $shm_hitalama_map_widget_float_application
		Iframe( ): $shm_hitalama_map_widget_float_iframe
		Text( ): $shm_hitalama_map_widget_float_text
		Image( ): $shm_hitalama_map_widget_float_image
		Drawing( ): $shm_hitalama_map_widget_float_drawing
		Rect( ): $shm_hitalama_map_widget_float_rect
		Circle( ): $shm_hitalama_map_widget_float_circle
		Text_md( ): $shm_hitalama_map_widget_float_text_md
		Form( ): $shm_hitalama_map_widget_float_form
		Table( ): $shm_hitalama_map_widget_float_table
		Table2( ): $shm_hitalama_map_widget_float_table2
		Surreal_table( ): $shm_hitalama_map_widget_float_surreal_table
		Tabulator( ): $shm_hitalama_map_widget_float_tabulator
		Code( ): $shm_hitalama_map_widget_float_code
		Component( ): $shm_hitalama_map_widget_float_component
		Component_view( ): $shm_hitalama_map_widget_float_component_view
		Component_parser( ): $shm_hitalama_map_widget_float_component_parser
		Chart( ): $shm_hitalama_map_widget_float_chart
		Echarts( ): $shm_hitalama_map_widget_float_echarts
		Chart_filter( ): $shm_hitalama_map_widget_float_chart_filter
		Customdom( ): $shm_hitalama_map_widget_float_customdom
		File( ): $shm_hitalama_map_widget_float_file
		Table_novirt( ): $shm_hitalama_map_widget_float_table_novirt
		Form_edit( ): $shm_hitalama_map_widget_float_form_edit
		Code_css( ): $shm_hitalama_map_widget_float_code_css
		Code_html( ): $shm_hitalama_map_widget_float_code_html
		Customizer( ): $shm_hitalama_map_widget_float_customizer
		Form_custom( ): $shm_hitalama_map_widget_float_form_custom
		Form2( ): $shm_hitalama_map_widget_float_form2
		Entity_editor( ): $shm_hitalama_map_widget_float_entity_editor
		Entity( ): $shm_hitalama_map_widget_float_entity
		Entity_field( ): $shm_hitalama_map_widget_float_entity_field
		Code_sql( ): $shm_hitalama_map_widget_float_code_sql
		Code_js( ): $shm_hitalama_map_widget_float_code_js
		Method( ): $shm_hitalama_map_widget_float_method
		Code_ts( ): $shm_hitalama_map_widget_float_code_ts
		Layout_vert( ): $shm_hitalama_map_widget_float_layout_vert
		Layout_hor( ): $shm_hitalama_map_widget_float_layout_hor
		Custom( ): $shm_hitalama_map_widget_float
		Chrome_telegram( ): $shm_hitalama_map_widget_float_chrome_telegram
		Viewport_frame( ): $shm_hitalama_map_widget_float_viewport_frame
		Tokens( ): $shm_hitalama_map_widget_float_tokens
		Posts( ): $shm_hitalama_map_widget_float_posts
		Prompt( ): $shm_hitalama_map_widget_float_prompt
		Ai_request( ): $shm_hitalama_map_widget_float_ai_request
		Opencode_session( ): $shm_hitalama_map_widget_float_opencode_session
		Notebook( ): $shm_hitalama_map_widget_float_notebook
		Notebook2( ): $shm_hitalama_map_widget_float_notebook2
		Notebook_edit( ): $shm_hitalama_map_widget_float_notebook_edit
		Notebook_preview( ): $shm_hitalama_map_widget_float_notebook_preview
		Group( ): $shm_hitalama_map_widget_float_group
		Settings( ): $shm_hitalama_map_widget_float_settings
		Settings_chart( ): $shm_hitalama_map_widget_float_settings_chart
		Settings_echarts( ): $shm_hitalama_map_widget_float_settings_echarts
		Settings_tabulator( ): $shm_hitalama_map_widget_float_settings_tabulator
		Settings_table( ): $shm_hitalama_map_widget_float_settings_table
		Settings_posts( ): $shm_hitalama_map_widget_float_settings_posts
		Settings_customdom( ): $shm_hitalama_map_widget_float_settings_customdom
		Settings_text_md( ): $shm_hitalama_map_widget_float_settings_text_md
		Settings_widget_page( ): $shm_hitalama_map_widget_float_settings_widget_page
		Autoview( ): $shm_hitalama_map_widget_float_autoview
		Sub_hack( id: any): $shm_hitalama_map_widget_float
		Sub( ): $shm_hitalama_map_widget_float
		custom_expose( ): any
		setup_obj( id: any): any
		widgets( ): ({ 
			'application': ReturnType< $shm_hitalama_map_widget_any['Application'] >,
			'iframe': ReturnType< $shm_hitalama_map_widget_any['Iframe'] >,
			'text': ReturnType< $shm_hitalama_map_widget_any['Text'] >,
			'image': ReturnType< $shm_hitalama_map_widget_any['Image'] >,
			'drawing': ReturnType< $shm_hitalama_map_widget_any['Drawing'] >,
			'rect': ReturnType< $shm_hitalama_map_widget_any['Rect'] >,
			'circle': ReturnType< $shm_hitalama_map_widget_any['Circle'] >,
			'text_md': ReturnType< $shm_hitalama_map_widget_any['Text_md'] >,
			'form': ReturnType< $shm_hitalama_map_widget_any['Form'] >,
			'table': ReturnType< $shm_hitalama_map_widget_any['Table'] >,
			'table2': ReturnType< $shm_hitalama_map_widget_any['Table2'] >,
			'surreal_table': ReturnType< $shm_hitalama_map_widget_any['Surreal_table'] >,
			'tabulator': ReturnType< $shm_hitalama_map_widget_any['Tabulator'] >,
			'code': ReturnType< $shm_hitalama_map_widget_any['Code'] >,
			'component': ReturnType< $shm_hitalama_map_widget_any['Component'] >,
			'component_view': ReturnType< $shm_hitalama_map_widget_any['Component_view'] >,
			'component_parser': ReturnType< $shm_hitalama_map_widget_any['Component_parser'] >,
			'chart': ReturnType< $shm_hitalama_map_widget_any['Chart'] >,
			'echarts': ReturnType< $shm_hitalama_map_widget_any['Echarts'] >,
			'chart_filter': ReturnType< $shm_hitalama_map_widget_any['Chart_filter'] >,
			'customdom': ReturnType< $shm_hitalama_map_widget_any['Customdom'] >,
			'file': ReturnType< $shm_hitalama_map_widget_any['File'] >,
			'table_novirt': ReturnType< $shm_hitalama_map_widget_any['Table_novirt'] >,
			'form_edit': ReturnType< $shm_hitalama_map_widget_any['Form_edit'] >,
			'code_css': ReturnType< $shm_hitalama_map_widget_any['Code_css'] >,
			'code_html': ReturnType< $shm_hitalama_map_widget_any['Code_html'] >,
			'customizer': ReturnType< $shm_hitalama_map_widget_any['Customizer'] >,
			'form_custom': ReturnType< $shm_hitalama_map_widget_any['Form_custom'] >,
			'form2': ReturnType< $shm_hitalama_map_widget_any['Form2'] >,
			'entity_editor': ReturnType< $shm_hitalama_map_widget_any['Entity_editor'] >,
			'entity': ReturnType< $shm_hitalama_map_widget_any['Entity'] >,
			'entity_field': ReturnType< $shm_hitalama_map_widget_any['Entity_field'] >,
			'code_sql': ReturnType< $shm_hitalama_map_widget_any['Code_sql'] >,
			'code_js': ReturnType< $shm_hitalama_map_widget_any['Code_js'] >,
			'method': ReturnType< $shm_hitalama_map_widget_any['Method'] >,
			'code_ts': ReturnType< $shm_hitalama_map_widget_any['Code_ts'] >,
			'layout_vert': ReturnType< $shm_hitalama_map_widget_any['Layout_vert'] >,
			'layout_hor': ReturnType< $shm_hitalama_map_widget_any['Layout_hor'] >,
			'custom': ReturnType< $shm_hitalama_map_widget_any['Custom'] >,
			'chrome_telegram': ReturnType< $shm_hitalama_map_widget_any['Chrome_telegram'] >,
			'viewport_frame': ReturnType< $shm_hitalama_map_widget_any['Viewport_frame'] >,
			'tokens': ReturnType< $shm_hitalama_map_widget_any['Tokens'] >,
			'posts': ReturnType< $shm_hitalama_map_widget_any['Posts'] >,
			'prompt': ReturnType< $shm_hitalama_map_widget_any['Prompt'] >,
			'ai_request': ReturnType< $shm_hitalama_map_widget_any['Ai_request'] >,
			'opencode_session': ReturnType< $shm_hitalama_map_widget_any['Opencode_session'] >,
			'notebook': ReturnType< $shm_hitalama_map_widget_any['Notebook'] >,
			'notebook2': ReturnType< $shm_hitalama_map_widget_any['Notebook2'] >,
			'notebook_edit': ReturnType< $shm_hitalama_map_widget_any['Notebook_edit'] >,
			'notebook_preview': ReturnType< $shm_hitalama_map_widget_any['Notebook_preview'] >,
			'group': ReturnType< $shm_hitalama_map_widget_any['Group'] >,
			'settings': ReturnType< $shm_hitalama_map_widget_any['Settings'] >,
			'settings_chart': ReturnType< $shm_hitalama_map_widget_any['Settings_chart'] >,
			'settings_echarts': ReturnType< $shm_hitalama_map_widget_any['Settings_echarts'] >,
			'settings_tabulator': ReturnType< $shm_hitalama_map_widget_any['Settings_tabulator'] >,
			'settings_table': ReturnType< $shm_hitalama_map_widget_any['Settings_table'] >,
			'settings_posts': ReturnType< $shm_hitalama_map_widget_any['Settings_posts'] >,
			'settings_customdom': ReturnType< $shm_hitalama_map_widget_any['Settings_customdom'] >,
			'settings_text_md': ReturnType< $shm_hitalama_map_widget_any['Settings_text_md'] >,
			'settings_widget_page': ReturnType< $shm_hitalama_map_widget_any['Settings_widget_page'] >,
			'autoview': ReturnType< $shm_hitalama_map_widget_any['Autoview'] >,
		}) 
	}
	
}

//# sourceMappingURL=any.view.tree.d.ts.map